var VMasker = {
  toMoney: function toMoney(value, opts, inEditMode) {
    if (value.substr(value.length - 1, 1) === '.') return value;
    var moneySplitOnDecimal = value.split('.');
    var isNegative = value.indexOf('-') > -1;
    var hasCents = moneySplitOnDecimal.length > 1;
    var initCents = '';
    var initMoney = moneySplitOnDecimal[0];

    if (hasCents) {
      initCents = moneySplitOnDecimal[1];
    }

    var money = initMoney.replace(/[\D]/g, ''),
        clearDelimiter = new RegExp('^(0|\\' + opts.delimiter + ')'),
        clearSeparator = new RegExp('(\\' + opts.separator + ')$'),
        masked = money.substr(0, money.length % 3),
        cents = hasCents ? initCents : '00';
    money = money.substr(money.length % 3, money.length);

    for (var i = 0, len = money.length; i < len; i++) {
      if (i % 3 === 0) {
        masked += opts.delimiter;
      }

      masked += money[i];
    }

    masked = masked.replace(clearDelimiter, '');
    masked = masked.length ? masked : '0';
    var output = '';

    if (inEditMode && !hasCents) {
      output = (isNegative ? '-' : '') + opts.unit + masked;
    } else if (inEditMode && isNegative) {
      output = '-' + opts.unit + masked + opts.separator + cents;
    } else {
      output = (isNegative ? '(' : '') + opts.unit + masked + opts.separator + cents + (isNegative ? ')' : '');
    }

    return output.replace(clearSeparator, '');
  },
  toPercentage: function toPercentage(value) {
    value = value.replace('%', '');

    if (value.length === 0) {
      return '%';
    } else if (value === '0') {
      return '0%';
    } else if (value === '.') {
      return '0.' + '%';
    } else {
      var values = value.split('.');

      switch (values.length) {
        case 1:
          if (value < 10000) return value + '%';
          break;

        case 2:
          var decimalValue = parseFloat(value);

          if (values[1].length > 2) {
            decimalValue = decimalValue.toFixed(2);

            if (!isNaN(decimalValue) && decimalValue < 10000) {
              return decimalValue + '%';
            }
          } else {
            if (!isNaN(decimalValue) && decimalValue < 10000) {
              return value + '%';
            }
          }

        default:
      }
    }
  },
  toPattern: function toPattern(value, opts) {
    var DIGIT = '9',
        ALPHA = 'A',
        ALPHANUM = 'S';

    var addPlaceholdersToOutput = function addPlaceholdersToOutput(output, index, placeholder) {
      for (; index < output.length; index++) {
        if (output[index] === DIGIT || output[index] === ALPHA || output[index] === ALPHANUM) {
          output[index] = placeholder;
        }
      }

      return output;
    };

    value = opts.last && value.length >= opts.last ? value.substr(value.length - opts.last) : value;
    var pattern = typeof opts === 'object' ? opts.pattern : opts,
        patternChars = pattern.replace(/\W/g, ''),
        output = pattern.split(''),
        values = value.toString().replace(/\W/g, ''),
        charsValues = values.replace(/\W/g, ''),
        index = 0,
        i,
        outputLength = output.length,
        placeholder = typeof opts === 'object' ? opts.placeholder : undefined;

    for (i = 0; i < outputLength; i++) {
      // handle last 4 ssn scenario
      if (opts.last && value.length >= opts.last) {
        if (i < outputLength - opts.last) {
          if (placeholder !== undefined && patternChars.length > charsValues.length) {
            output = addPlaceholdersToOutput(output, i, placeholder).join('');
          }
        } else {
          // Remaining chars in input
          if (output[i] === DIGIT && values[index].match(/[0-9]/) || output[i] === ALPHA && values[index].match(/[a-zA-Z]/) || output[i] === ALPHANUM && values[index].match(/[0-9a-zA-Z]/)) {
            output[i] = values[index++];
          } else if (output[i] === DIGIT || output[i] === ALPHA || output[i] === ALPHANUM) {
            if (placeholder !== undefined) {
              return addPlaceholdersToOutput(output, i, placeholder).join('');
            } else {
              return output.slice(0, i).join('');
            }
          }
        }
      } else {
        // Reached the end of input
        if (index >= values.length) {
          if (patternChars.length === charsValues.length) {
            return output.join('');
          } else if (placeholder !== undefined && patternChars.length > charsValues.length) {
            return addPlaceholdersToOutput(output, i, placeholder).join('');
          } else {
            break;
          }
        } else {
          // Remaining chars in input
          if (output[i] === DIGIT && values[index].match(/[0-9]/) || output[i] === ALPHA && values[index].match(/[a-zA-Z]/) || output[i] === ALPHANUM && values[index].match(/[0-9a-zA-Z]/)) {
            output[i] = values[index++];
          } else if (output[i] === DIGIT || output[i] === ALPHA || output[i] === ALPHANUM) {
            if (placeholder !== undefined) {
              return addPlaceholdersToOutput(output, i, placeholder).join('');
            } else {
              return output.slice(0, i).join('');
            }
          }
        }
      }
    }

    return output.join('').substr(0, i);
  },
  toNumber: function toNumber(value) {
    if (value === '') {
      return '';
    } else {
      return value.toString().replace(/(?!^-)[^0-9]/g, '');
    }
  },
  toAlphaNumeric: function toAlphaNumeric(value) {
    return value.toString().replace(/[^a-z0-9 ]+/i, '');
  }
};
export default VMasker;